/**
 * @fileoverview Hook UI Layer para configuración visual del modal de transacción de pago.
 * @module usePaymentTransactionUI
 * @category Hook - UI Layer
 * @since 3.1.0
 * @version 3.1.0
 */
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook UI Layer para configuración visual del modal de pago.
 *
 * - Solo maneja configuraciones visuales y textos.
 * - No contiene lógica de negocio ni de formulario.
 * - Optimizaciones: useMemo para props estáticas.
 *
 * @function usePaymentTransactionUI
 * @returns {Object} { modalTitle, containerClassName, modalClassName, headerClassName, footerClassName }
 * @see usePaymentTransactionForm
 * @see usePaymentTransactionActions
 */
export function usePaymentTransactionUI() {
  const { t } = useTranslation('InboxMC');
  const getButtons = useCallback(({ loading, handleSaveButtonClick }) => [
    {
      icon: loading ? 'sync-outline' : null,
      label: t('customerDetails.save'),
      onClick: handleSaveButtonClick,
      className: 'tw-w-full',
      disabled: loading
    }
  ], [t]);

  return useMemo(() => ({
    modalTitle: t('orders.payment_status_title'),
    containerClassName: '!tw-max-w-2xl',
    modalClassName: 'tw-fixed tw-top-0 tw-right-0 tw-w-1/3 tw-h-full !tw-rounded-none tw-flex tw-flex-col !tw-p-0',
    headerClassName: 'tw-w-full tw-border-b tw-border-gray-200 tw-p-4',
    footerClassName: 'tw-w-full tw-border-t tw-border-gray-200 tw-p-4',
    getButtons
  }), [t]);
}
